export const Apis = {
  Login_verifyPin: 'trillium-patient-service/v1/review/login',
  Login_saveReview: 'trillium-patient-service/v1/review/',
}
